import React from "react";
import { ResumeComponent } from "../commons/resume";
import companies from "./companies";

const Experience = () => {
  return (
    <div>
      {companies.map((company, index) => (
        <ResumeComponent
          key={index}
          period={company.period}
          title={company.title}
          subtitle={company.subtitle}
          description={company.description}
        />
      ))}
    </div>
  );
};

export default Experience;
